var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentHomework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5625 1.88037C6.31387 1.8804 6.07543 1.97918 5.89962 2.15499C5.72381 2.3308 5.62502 2.56924 5.625 2.81787V3.75537H3.75C2.72557 3.75537 1.875 4.60594 1.875 5.63037V26.2554C1.875 27.2798 2.72557 28.1304 3.75 28.1304H15H26.25C27.2744 28.1304 28.125 27.2798 28.125 26.2554V5.63037C28.125 4.60594 27.2744 3.75537 26.25 3.75537H24.375V2.81787C24.375 2.56924 24.2762 2.3308 24.1004 2.15499C23.9246 1.97918 23.6861 1.8804 23.4375 1.88037H18.75C17.2183 1.88037 15.8568 2.6283 15 3.77368C14.1432 2.6283 12.7817 1.88037 11.25 1.88037H6.5625ZM7.5 3.75537H11.25C12.8144 3.75537 14.0625 5.00346 14.0625 6.56787V23.5454C13.2699 22.9323 12.3234 22.5054 11.25 22.5054H7.5V4.69287V3.75537ZM18.75 3.75537H22.5V4.69287V22.5054H18.75C17.6766 22.5054 16.7301 22.9323 15.9375 23.5454V6.56787C15.9375 5.00346 17.1856 3.75537 18.75 3.75537ZM3.75 5.63037H5.625V23.4429C5.62502 23.6915 5.72381 23.9299 5.89962 24.1058C6.07543 24.2816 6.31387 24.3803 6.5625 24.3804H11.25C12.4844 24.3804 13.5186 25.159 13.9014 26.2554H3.75V5.63037ZM24.375 5.63037H26.25V26.2554H16.0986C16.4814 25.159 17.5156 24.3804 18.75 24.3804H23.4375C23.6861 24.3803 23.9246 24.2816 24.1004 24.1058C24.2762 23.9299 24.375 23.6915 24.375 23.4429V5.63037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentHomework);
export default __webpack_public_path__ + "static/media/CurrentHomework.4fa05d352ae63f7f3d5240ac0f1b31ba.svg";
export { ForwardRef as ReactComponent };